import { Loader } from "@mantine/core"

export function InputLoader({ loading }: { loading?: boolean }) {
  return loading ? <Loader size="xs" variant="oval" color="gray" /> : undefined
}
